import React, { useEffect, useState } from "react";
import { Form, Offcanvas, Button } from "react-bootstrap";
import Swal from "sweetalert2";
import { inviteServices } from "../../../APIServices/UserData/inviteServices";
import { designationServices } from "../../../APIServices/UserData/designationServices";
import { accountServices } from "../../../APIServices/GlobalManagements/accountServices";

const SendInvitation = ({ show, hide, title, getInvitationList, organizationList }) => {
  const [loader, setLoader] = useState(false);
  const [email, setEmail] = useState("");
  const [designationId, setDesignationId] = useState("");
  const [designations, setDesignations] = useState([]);
  const [assignedAccount, setAssignedAccount] = useState([]);
  const [accountList, setAccountList] = useState([]);

  const inviteUser = async () => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to send invittaion to this email?",
      icon: "warning",
      showCancelButton: true,
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, send it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setLoader(true)
        let userData = {}
        userData.email = email
        userData.designationId = designationId
        userData.assignedAccount = assignedAccount
        let data = await inviteServices.inviteUser(userData)
        if (data?.statusCode === 200) {
          getInvitationList()
          clearData();
        }
        setLoader(false)
      }
    });
  };

  const clearData = () => {
    setEmail("");
    setDesignationId("");
    setAssignedAccount([]);
    setLoader(false)
    hide();
  }

  const getDesignationList = async () => {
    let data = await designationServices.getDesignationList("active")
    setDesignations(data?.data || [])
  }

  const getAccountList = async (adminId) => {
    let data = await accountServices.getAccountList(adminId, "active")
    setAccountList(data?.data || [])
  }

  useEffect(() => {
    if (!show) {
      setEmail("");
      setDesignationId("");
      setAssignedAccount([]);
      setLoader(false)
      getDesignationList()
      if (organizationList?.length === 1) {
        getAccountList(organizationList?.[0]?.adminId)
      }
    }
  }, [show, organizationList]);

  const handleCheckbox = (userId, checked) => {
    if (checked) {
      setAssignedAccount((prev) => [...prev, userId]);
    } else {
      setAssignedAccount((prev) => prev.filter((id) => id !== userId));
    }
  };

  const handleSelectAll = (checked) => {
    if (checked) {
      setAssignedAccount(accountList.map((m) => m.accountId));
    } else {
      setAssignedAccount([]);
    }
  };
  return (
    <Offcanvas show={show} onHide={hide} placement="end">
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>{title}</Offcanvas.Title>
      </Offcanvas.Header>

      <Offcanvas.Body>
        <Form>
          <Form.Group className="mb-2">
            <Form.Label>
              Email <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              name="userName"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter Name"
            />
          </Form.Group>
          <Form.Group className="mb-2">
            <Form.Label>
              Designation <span className="text-danger">*</span>
            </Form.Label>
            <Form.Select
              className="interactive-input"
              style={{ fontSize: 14 }}
              onChange={(e) => setDesignationId(e.target.value)}
              value={designationId}
            >
              <option value="">Select Designation</option>
              {designations?.map(item => (
                <option value={item?.designationId}>{item?.name}</option>
              ))}
            </Form.Select>
          </Form.Group>
          <Form.Group className="mb-2">
            <Form.Label className="fw-bold mb-1" style={{ fontSize: 13 }}>
              Assign Account{" "}
              <abbr className="text-danger" title="Require">
                *
              </abbr>
            </Form.Label>
            {accountList?.length > 0 && (
              <Form.Check
                type="checkbox"
                label="Select All"
                checked={assignedAccount?.length === accountList?.length}
                onChange={(e) => handleSelectAll(e.target.checked)}
                style={{ fontSize: 12 }}
              />
            )}
            {accountList?.map((item, index) => (
              <Form.Check
                key={index}
                type="checkbox"
                label={item?.name}
                checked={assignedAccount?.includes(item.accountId)}
                onChange={(e) => handleCheckbox(item.accountId, e.target.checked)}
                style={{ fontSize: 12 }}
              />
            ))}
          </Form.Group>
          <div className="d-flex justify-content-end gap-2 mt-3">
            <Button onClick={clearData} style={{ fontSize: 12 }} variant="light" >
              Cancel
            </Button>
            <Button
              disabled={!email || !designationId || (assignedAccount?.length === 0) || loader}
              onClick={inviteUser}
              style={{ fontSize: 12 }}>
              {title}
            </Button>
          </div>
        </Form>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default SendInvitation;
